import axios from "axios";

const openEmrApi = axios.create({
  baseURL: "/openemr/frisco/customapi", // neutered: was prod emr.brainymed.com
});

// ✅ RESPONSE INTERCEPTOR
openEmrApi.interceptors.response.use(
  (response) => {
    // Instead of returning full Axios response object,
    // this returns ONLY the data portion.
    return response.data;
  },
  (error) => {
    // Handle errors globally if needed
    return Promise.reject(error);
  }
);

export default openEmrApi;
